import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Box,
  Divider,
  Avatar,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  Camera,
  CloudUpload,
  TrendingUp,
  Stars,
  PhotoLibrary,
  AccountCircle,
  ExitToApp,
  Book,
} from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    position: 'fixed',
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 1300,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
    },
  },
  drawer: {
    width: 280,
  },
  drawerPaper: {
    width: 280,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
  },
  header: {
    padding: theme.spacing(3, 2),
    textAlign: 'center',
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: 'white',
  },
  listItem: {
    borderRadius: theme.spacing(1),
    margin: theme.spacing(0.5, 1),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  activeItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
  },
  listItemIcon: {
    color: 'white',
    minWidth: 40,
  },
  listItemText: {
    '& .MuiTypography-root': {
      fontWeight: 500,
    },
  },
  logoutItem: {
    marginTop: theme.spacing(2),
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
  userInfo: {
    marginTop: theme.spacing(1),
  },
  avatar: {
    width: 50,
    height: 50,
    margin: '0 auto',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    marginBottom: theme.spacing(1),
  },
}));

const menuItems = [
  { path: '/guide', label: 'Photo Guide', icon: Book },
  { path: '/upload', label: 'Upload Photos', icon: CloudUpload },
  { path: '/training', label: 'Training Progress', icon: TrendingUp },
  { path: '/generate', label: 'Generate Photos', icon: Stars },
  { path: '/gallery', label: 'Gallery', icon: PhotoLibrary },
  { path: '/account', label: 'Account', icon: AccountCircle },
];

function BurgerMenu() {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { currentUser, logout } = useAuth();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (path) => {
    history.push(path);
    setIsOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      history.push('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <>
      <IconButton
        className={classes.menuButton}
        onClick={handleToggle}
        aria-label="menu"
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        anchor="left"
        open={isOpen}
        onClose={handleToggle}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawer}>
          <div className={classes.header}>
            <IconButton
              className={classes.closeButton}
              onClick={handleToggle}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            
            <Avatar className={classes.avatar}>
              <Camera />
            </Avatar>
            
            <Typography variant="h6" gutterBottom>
              InstaWorthy
            </Typography>
            
            {currentUser && (
              <div className={classes.userInfo}>
                <Typography variant="body2" style={{ opacity: 0.9 }}>
                  {currentUser.email}
                </Typography>
              </div>
            )}
          </div>

          <List>
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <ListItem
                  button
                  key={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={`${classes.listItem} ${isActive ? classes.activeItem : ''}`}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <Icon />
                  </ListItemIcon>
                  <ListItemText 
                    primary={item.label}
                    className={classes.listItemText}
                  />
                </ListItem>
              );
            })}
            
            <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', margin: '16px' }} />
            
            <ListItem
              button
              onClick={handleLogout}
              className={`${classes.listItem} ${classes.logoutItem}`}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText 
                primary="Logout"
                className={classes.listItemText}
              />
            </ListItem>
          </List>
        </div>
      </Drawer>
    </>
  );
}

export default BurgerMenu;